import React, { Component } from 'react';
import Iframe from './_NewIframe';

class Updater extends Component {
  render() {
    if (this.props.resizeStop) {
      const key = JSON.stringify(Math.random()).slice(2)
      return <Iframe key={key} styleProps={this.props.styleProps} envelope={this.props.envelope}/>;
    }
    return null;
    // console.log(this.props.resizeStop);
    //
    // const key = JSON.stringify(Math.random()).slice(2)
    // return this.props.resizeStop ? (
    //   <Iframe key={key} styleProps={this.props.styleProps} envelope={this.props.envelope}/>
    // ) : null;
  }
}

export default Updater;



// WEBPACK FOOTER //
// ./src/_Updater.js